import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFirstScrollableParent } from '../../../../../../../../../../../shared/utils/uiEffects/scrollTo';

import { LoadingCircle, SlotsSelector, Card } from 'hosman-material';
import { S_Check } from 'hosman-material';

import { getSlots, resetSlots, updateFormValues } from '../../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const SlotSelection = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { newPhotoMeetingParams: { requestState, availableSlots, formValues }} = useSelector((state) => state.sellerPhotoMeetings);
  const [daysDisplayed, setDaysDisplayed] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSlots(sale.id))

    return () => dispatch(resetSlots())
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleDaysDisplayed);
    handleDaysDisplayed();
  }, []);

  const handleDaysDisplayed = () => {
    const number = window.innerWidth > 460 ? 4 : 2

    setDaysDisplayed(number)
  }

  useEffect(() => {
    window.addEventListener('resize', handleDaysDisplayed);
    handleDaysDisplayed();
  }, []);

  const handleSelect = (e) => {
    dispatch(updateFormValues({ ...formValues, start_date: e }));
    
    const modal = getFirstScrollableParent(document.getElementById('ModalContent'));    
    modal.scrollTo({
      top: modal.scrollHeight,
      behavior: 'smooth'
    });
  }

  if (requestState === 'pending') return <div className='w-full flex justify-around'><LoadingCircle /></div>
  if (requestState === 'done' && availableSlots.length < 1) return <p className='w-full text-center'>Aucun créneau disponible.</p>

  return (
    <Card classes='flex flex-col gap-10 mx-auto p-6'>
      <SlotsSelector
        slots={availableSlots}
        onSelect={handleSelect}
        daysDisplayed={daysDisplayed}
      />

      <div className='flex justify-center items-center gap-3'>
        <FontAwesomeIcon icon={S_Check} className='text-xs flex items-center justify-center p-1 rounded-full bg-ih-blue text-white' />
        <p className='text-ih-indigo'>Un bien est plus attractif meublé : privilégiez la prestation avant un éventuel déménagement.</p>
      </div>
    </Card>
  )
}

export default SlotSelection;
